import React from "react"

const Astro=()=>{
   return (
     <h1>Astro</h1>
   )
}

export default Astro